import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { createRegisterableComponent } from '@news-mono/web-common'
import * as React from 'react'
import { Redirect } from 'react-router'
import { NewsletterSignup } from '../banners/NewsletterSignup/NewsletterSignup'
import { RecaptchaProvider } from '../recaptcha/Recaptcha'
import { ThemedRender } from '../__styling'
import { NewsletterSubscription } from './NewsletterSubscription'

export const NewsletterSubscriptionRegistration = createRegisterableComponent(
    'newsletter-subscription',
    (_, services) => {
        if (
            !services.config.recaptureSiteKey ||
            !services.config.sendgridEnv ||
            !isFeatureEnabled(
                toFeatureState(services.store.getState().toggles),
                'newsletter-subscriptions',
            )
        ) {
            return (
                <ThemedRender
                    thewest={() => {
                        return <Redirect to={'/newsletter-redirect'} /> // ssr redirect in app
                    }}
                    perthnow={() => (
                        <NewsletterSignup
                            text="The latest from PerthNow delivered to your inbox daily."
                            buttonLabel="Sign Up"
                            verticalSpacing="md"
                            api={services.config.contentApi}
                            onEvent={services.onEvent}
                        />
                    )}
                />
            )
        }

        return (
            <RecaptchaProvider siteKey={services.config.recaptureSiteKey}>
                <NewsletterSubscription
                    sendgridEnv={services.config.sendgridEnv}
                />
            </RecaptchaProvider>
        )
    },
)
